module.exports = __webpack_public_path__ + "img/chinadian.09b468ae.png";